
(function () {

  function initIngredientBundle() {

    const sections = document.querySelectorAll(
      '.ingredient-bundle'
    );

    sections.forEach(function (section) {

      if (section.dataset.ingredientBundleInitialized) {
        return;
      }

      section.dataset.ingredientBundleInitialized = 'true';


      const tabs = section.querySelectorAll(
        '[data-ingredient-tab]'
      );

      const contents = section.querySelectorAll(
        '[data-ingredient-content]'
      );


      if (!tabs.length || !contents.length) {
        return;
      }


      tabs.forEach(function (tab) {

        tab.addEventListener('click', function () {

          const target =
            this.getAttribute(
              'data-ingredient-tab'
            );


          /* ==============================
             REMOVE ACTIVE TAB
             ============================== */

          tabs.forEach(function (item) {

            item.classList.remove(
              'is-active'
            );

            item.setAttribute(
              'aria-selected',
              'false'
            );

          });


          /* ==============================
             HIDE ALL CONTENT
             ============================== */

          contents.forEach(function (content) {

            content.classList.remove(
              'is-active'
            );

          });


          /* ==============================
             ACTIVATE SELECTED TAB
             ============================== */

          this.classList.add(
            'is-active'
          );

          this.setAttribute(
            'aria-selected',
            'true'
          );


          const activeContent =
            section.querySelector(
              '[data-ingredient-content="' +
              target +
              '"]'
            );


          if (activeContent) {

            activeContent.classList.add(
              'is-active'
            );

          }

        });

      });

    });

  }


  /* Initial load */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initIngredientBundle
    );

  } else {

    initIngredientBundle();

  }


  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.ingredient-bundle'
        );

      if (section) {
        initIngredientBundle();
      }

    }
  );

})();
